import { api } from ".";
import {
  IEdiConversionFile,
  IEdiUploadMapping,
} from "../../types/ediConversionFile";

const ediConversionQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllEdiConversionFiles: builder.query<
      { data: IEdiConversionFile[]; message: string },
      { search?: string }
    >({
      query: (params) => ({
        url: "/edi-conversion",
        params,
      }),
      providesTags: ["EdiConversion"],
    }),
    getEdiConversionFileById: builder.query<
      { data: IEdiConversionFile; message: string },
      string
    >({
      query: (id) => `/edi-conversion/${id}`,
    }),
    // CLE-2236: one upload now carries 1–3 provider-mapping rules and fans out into one
    // EdiConversionFile per rule, so the response is an array.
    convertAndUploadEdi: builder.mutation<
      { data: IEdiConversionFile[]; message: string; warnings?: string[] },
      {
        files: File[];
        displayName: string;
        description?: string;
        mappings: IEdiUploadMapping[];
        files837?: File[];
      }
    >({
      query: ({ files, displayName, description, mappings, files837 }) => {
        const formData = new FormData();
        files.forEach((f) => formData.append("files", f));
        if (files837) {
          files837.forEach((f) => formData.append("files837", f));
        }
        formData.append("displayName", displayName);
        if (description) {
          formData.append("description", description);
        }
        formData.append("mappings", JSON.stringify(mappings));

        return {
          url: "/edi-conversion/convert",
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["EdiConversion"],
    }),
    getEdiConversionFileDownloadUrl: builder.query<
      { url: string; message: string },
      string
    >({
      query: (id) => `/edi-conversion/${id}/download`,
    }),
    deleteEdiConversionFile: builder.mutation<{ message: string }, string>({
      query: (id) => ({
        url: `/edi-conversion/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["EdiConversion"],
    }),
    reprocessEdiFile: builder.mutation<
      { data: IEdiConversionFile; message: string },
      string
    >({
      query: (id) => ({
        url: `/edi-conversion/${id}/reprocess`,
        method: "POST",
      }),
      invalidatesTags: ["EdiConversion"],
    }),
    runAiAnalysis: builder.mutation<
      { data: { claimCount: number }; message: string },
      string
    >({
      query: (id) => ({
        url: `/edi-conversion/${id}/run-ai-analysis`,
        method: "POST",
      }),
      invalidatesTags: ["EdiConversion"],
    }),
  }),
});

export const {
  useGetAllEdiConversionFilesQuery,
  useGetEdiConversionFileByIdQuery,
  useConvertAndUploadEdiMutation,
  useGetEdiConversionFileDownloadUrlQuery,
  useDeleteEdiConversionFileMutation,
  useReprocessEdiFileMutation,
  useRunAiAnalysisMutation,
} = ediConversionQueries;
